import React, { useCallback } from 'react';

import { updateTask } from 'actions/tasks';

import TaskName from 'components/task-name';
import TaskCompleteWrap from 'components/TaskCompleteWrap';
import SubtaskUtils from 'components/SubtaskUtils';

import IconClose from 'icons/icon-close';
import IconArrowLeft from 'icons/icon-arrow-left';
import IconMoreHoriz from 'icons/icon-more-horiz';

const SubtaskSingle = ({ id, projectId, discussionElement, onClose, onDelete }) => {
    const handleCompleteToggle = useCallback(completed => {
        updateTask(id, { completed });
    }, [id]);

    return (
        <div className="content-panel-main">
            <div className="content-panel-head">
                <div className="content-panel-subview-head">
                    <button className="content-panel-control btn content-panel-back" onClick={onClose}><IconArrowLeft size="20px" /></button>

                    <div className="content-panel-subview-head-main">
                        <TaskCompleteWrap
                            id={id}
                            dark={true}
                            onChange={handleCompleteToggle}
                        />

                        <div className="content-panel-subview-title">
                            <TaskName id={id} />
                        </div>
                    </div>

                    <div className="content-panel-controls">
                        <div className="content-panel-simple-actions">
                            <div className="content-panel-control">
                                <SubtaskUtils
                                    id={id} 
                                    projectId={projectId}
                                    btnClassName="content-panel-actions-trigger"
                                    icon={<IconMoreHoriz size="16px" />}
                                    onDelete={onDelete}
                                >
                                    <span className="content-panel-actions-trigger"><i className="material-icons">more_horiz</i></span>
                                </SubtaskUtils>
                            </div>

                            <button className="content-panel-control btn content-panel-close" onClick={onClose}><IconClose /></button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content-panel-body">
                { discussionElement }
            </div>
        </div>
    );
}

export default SubtaskSingle;
